import React, { useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";

import main from '../img/Home/main.png'

import Footer from "../components/Footer";

import waved from "../img/ContactUs/waved.png";
import wavem from '../img/ContactUs/wavem.png'

import Fade from 'react-reveal/Fade'

function ContactUs () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    const { t } = useTranslation();
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <div className="relative">
                <img src={main} alt="" className="w-full h-[722px] object-cover"/>
                <img
                    src={waved}
                    alt="ab decoration"
                    className="absolute top-0 right-[400px] h-full z-20 hidden md:block"
                />
                <img
                    src={wavem}
                    alt="ab decoration"
                    className="absolute bottom-0 right-0 w-full z-20 md:hidden block"
                />
                <div className="absolute flex flex-col z-50 top-0 left-1/2 -translate-x-1/2 w-full max-w-[1220px] px-5">
                    <Fade left><p className="max-w-[504px] mt-[40px] md:mt-[100px] poppins text-[24px] xl:text-[48px] spanmain font-[500] text-[#061A77] leading-[1.2]"><Trans>{t('contactus.1')}</Trans></p></Fade>
                    <div className="mt-[80px] xl:mt-[120px]">
                        <p className="inter text-[#000000B2] text-[14px]">{t('contactus.2')}</p>
                        <div className="flex items-center gap-[12px] mt-[4px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M6.00024 0C3.60387 0 1.6543 1.94958 1.6543 4.34592C1.6543 7.31986 5.54349 11.6858 5.70908 11.8702C5.86461 12.0434 6.13616 12.0431 6.29141 11.8702C6.45699 11.6858 10.3462 7.31986 10.3462 4.34592C10.3461 1.94958 8.39659 0 6.00024 0ZM6.00024 6.53248C4.79457 6.53248 3.81371 5.55159 3.81371 4.34592C3.81371 3.14025 4.79459 2.15939 6.00024 2.15939C7.20589 2.15939 8.18675 3.14027 8.18675 4.34595C8.18675 5.55162 7.20589 6.53248 6.00024 6.53248Z" fill="#65CDBF"/>
                            </svg>
                            <p className="inter text-[#000000B2] text-[14px] font-[500]">Talacker 35, 8001 Zürich, Switzerland</p>
                        </div>
                    </div>
                    <div className="mt-[20px] xl:mt-[40px]">
                        <p className="inter text-[#000000B2] text-[14px]">{t('contactus.3')}</p>
                        <div className="flex items-center gap-[12px] mt-[4px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <g clip-path="url(#clip0_8954_869)">
                                    <path d="M11.7459 9.29201C11.5833 9.11037 11.0831 8.65755 10.725 8.38779C10.3734 8.11146 9.79755 7.73763 9.57326 7.62185C9.20693 7.4313 8.65498 7.45263 8.31209 7.68302C8.03028 7.87912 7.76931 8.10357 7.53326 8.35287L7.5281 8.35826C7.39918 8.49448 7.22604 8.58045 7.0396 8.60085C6.85316 8.62124 6.66553 8.57472 6.51021 8.46959C5.92618 8.07133 5.3811 7.61877 4.88224 7.11795C4.38141 6.61908 3.92885 6.074 3.5306 5.48998C3.42547 5.33466 3.37895 5.14703 3.39934 4.96059C3.41973 4.77414 3.50571 4.60101 3.64193 4.47209L3.64732 4.46693C3.89662 4.23088 4.12107 3.96991 4.31716 3.6881C4.54755 3.34521 4.56888 2.79326 4.37834 2.42693C4.26255 2.20287 3.88873 1.62771 3.6124 1.27521C3.3424 0.917086 2.88982 0.41693 2.70818 0.254273C2.4117 -0.0129141 1.91084 -0.0825235 1.56138 0.107789C1.26785 0.274496 0.992866 0.471933 0.74107 0.696773L0.714586 0.720211C-0.830414 2.04935 0.186774 5.75927 3.21607 8.78271C6.24115 11.8125 9.95013 12.8304 11.2793 11.2854L11.3027 11.2589C11.5276 11.0071 11.7251 10.7322 11.8917 10.4386C12.0827 10.0894 12.0131 9.58849 11.7459 9.29201Z" fill="#65CDBF"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_8954_869">
                                    <rect width="12" height="12" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p className="inter text-[#000000B2] text-[14px] font-[500]">+41415330674</p>
                        </div>
                        <div className="flex items-center gap-[12px] mt-[4px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M6.34711 7.51592C6.23377 7.58676 6.10626 7.61509 5.99292 7.61509C5.87957 7.61509 5.75207 7.58676 5.63872 7.51592L0 4.07318V8.64933C0 9.6269 0.793388 10.4203 1.77096 10.4203H10.229C11.2066 10.4203 12 9.6269 12 8.64933V4.07318L6.34711 7.51592Z" fill="#65CDBF"/>
                                <path d="M10.229 1.57971H1.77093C0.935035 1.57971 0.226652 2.17475 0.0566406 2.96814L6.00705 6.59506L11.9433 2.96814C11.7733 2.17475 11.0649 1.57971 10.229 1.57971Z" fill="#65CDBF"/>
                            </svg>
                            <p className="inter text-[#000000B2] text-[14px] font-[500]">support@{window.location.host}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-[-80px] xl:mt-[-140px]">
                <Footer titleKey="ambassador.23" />
            </div>
        </div>
    );
}

export default ContactUs;